import {
  Box,
  Chip,
  Divider,
  Paper,
  Typography,
  TextField,
} from "@mui/material";
import { Stack } from "@mui/system";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Card from "../../Components/Students/Card";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../Api/axios.instance";
import useSession from "../../CustomHooks/useSession";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CircularProgress from "@mui/material/CircularProgress";

export function getAllStudents(schoolId) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data, status } = await axiosInstance.get(
        `/students/by-school-all/${schoolId}`,
      );
      if (status === 200) {
        resolve(data);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export default function StudentsWrapper() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchType, setSearchType] = useState({
    text: "GR NO",
    value: "GRNO",
  });
  const [searchText, setSearchText] = useState("");
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  const [originalStudents, setOriginalStudents] = useState([]);
  const { accesLevel, access, currentPage } = useSession();
  const [currentPageCRUD] = useState(currentPage[0] ? currentPage[0] : "");
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [formData, setFormData] = useState({
    StatusCode: "ACTIVE",
  });
  useEffect(() => {
    if (
      accesLevel === "SCHOOL" ||
      accesLevel === "ADMIN" ||
      accesLevel === "CLUSTER"
    ) {
      _fetchStudents();
    }
  }, [formData.StatusCode]);

  const _handleOnChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const _fetchStudents = async () => {
    const accessObject = Object.assign({}, access);
    try {
      const students = await getAllStudents(accessObject[0].SchoolId);
      let filteredData = students.data;
      if (formData.StatusCode) {
        filteredData = filteredData.filter(
          (item) => item.StatusCode === formData.StatusCode,
        );
      }
      setStudents(filteredData);
      // console.log("ALL STUDENT", students.data);
      setOriginalStudents(filteredData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleClickOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (param, paramText) => (e) => {
    setSearchType({
      text: paramText,
      value: param,
    });
    setAnchorEl(null);
  };
  const onSearchChange = (e) => {
    setSearchText(e.target.value);
    search(e.target.value);
  };
  const search = debounce((val) => {
    if (val.trim().length === 0) {
      setStudents(originalStudents);
      return;
    }
    const filteredRows = students.filter((row) => {
      return row[searchType.value]
        .toLowerCase()
        .trim()
        .includes(val.toLowerCase().trim());
    });
    setStudents(filteredRows);
  }, 500);
  const _onClickAdd = useCallback(() => {
    navigate("add");
  }, []);
  const _onClickPromote = useCallback(() => {
    navigate("/promote-students");
  }, []);
  const _removeStudent = (id) => {
    setStudents((prevState) => {
      return prevState.filter((item) => item.SID !== id);
    });
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Stack
        sx={{ mb: 2 }}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack>
          <Typography variant="h6" component="h1">
            Student Details
          </Typography>
        </Stack>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          gap={2}
        >
          {currentPageCRUD.create && (
            <Button onClick={_onClickAdd} variant="contained">
              Add New Student
            </Button>
          )}
          {currentPageCRUD.create && (
            <Button
              onClick={_onClickPromote}
              color="secondary"
              variant="outlined"
            >
              Promote Student
            </Button>
          )}
        </Box>
      </Stack>
      <Divider sx={{ mt: 1, mb: 2 }} />

      <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
        <Grid container spacing={2} mb={2}>
          <Grid Grid item xs={12} md={9}>
            {currentPageCRUD.read && (
              <Paper
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 500,
                }}
              >
                <InputBase
                  value={searchText}
                  onChange={onSearchChange}
                  sx={{ ml: 1, flex: 1, fontSize: 13 }}
                  placeholder="Search Students"
                  inputProps={{ "aria-label": "search students" }}
                />
                <Button onClick={handleClickOpen}>{searchType.text}</Button>
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Paper>
            )}
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              id="standard-select-currency"
              select
              label="Status of Student"
              sx={{ display: "flex", flex: 1 }}
              variant="outlined"
              size="small"
              name="StatusCode"
              value={formData.StatusCode}
              onChange={_handleOnChange}
            >
              <MenuItem value="ACTIVE">ACTIVE</MenuItem>
              <MenuItem value="DROPOUT">DROPOUT</MenuItem>
              <MenuItem value="PASSOUT">PASSOUT</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 1, mb: 1 }} />
        {/*<Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Chip
          sx={{ mr: 1 }}
          avatar={
            // <Avatar alt="Natacha" src={} />
            <AccountCircleIcon sx={{ width: 20, height: 20 }} />
          }
          className="cursor-pointer"
          label="CLASS WISE STUDENTS"
          variant="outlined"
          onClick={() => navigate("/reports/class-wise-students")}
        />
        <Chip
          sx={{ mr: 1 }}
          avatar={
            // <Avatar alt="Natacha" src={} />
            <AccountCircleIcon sx={{ width: 20, height: 20 }} />
          }
          className="cursor-pointer"
          label="DROPOUTS"
          variant="outlined"
          onClick={() => navigate("/reports/dropout-students")}
        />
        <Chip
          sx={{ mr: 1 }}
          avatar={
            // <Avatar alt="Natacha" src={} />
            <AccountCircleIcon sx={{ width: 20, height: 20 }} />
          }
          className="cursor-pointer"
          label="ORPHANS"
          variant="outlined"
          onClick={() => navigate("/reports/orphans-strength")}
        />
        <Chip
          sx={{ mr: 1 }}
          avatar={
            // <Avatar alt="Natacha" src={} />
            <AccountCircleIcon sx={{ width: 20, height: 20 }} />
          }
          className="cursor-pointer"
          label="MALE FEMALE RATIO"
          variant="outlined"
          onClick={() => navigate("/reports/male-female-ratio")}
        />
      </Grid>
    </Grid>
    <Divider sx={{ mt: 2, mb: 1 }} />*/}
        <Box flexGrow={1}>
          <Grid container spacing={3} sx={{ mt: 2 }}>
            {currentPageCRUD.read &&
              students.map((student, index) => (
                <Grid key={index} xs={12} sm={6} md={4} lg={3}>
                  <Card student={student} deleteStudent={_removeStudent} />
                </Grid>
              ))}
          </Grid>
        </Box>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleClose("GRNO", "GR NO")}>GRNO</MenuItem>
          <MenuItem onClick={handleClose("StudentName", "Student Name")}>
            Student Name
          </MenuItem>
          <MenuItem onClick={handleClose("FathersName", "Father's Name")}>
            Father's Name
          </MenuItem>
          <MenuItem onClick={handleClose("NIC_Father", "Father's CNIC")}>
            Father's CNIC
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
}
